import { createFileRoute } from "@tanstack/react-router";
import { PrototypesGuard } from "../pages/Prototypes/PrototypesGuard";

export const Route = createFileRoute("/prototypes")({
  component: PrototypesGuard,
});
